<template>
  <div class="tags-view">
    <span class="tags-view__home">AI工作平台</span>
    <span class="tags-view__separator">/</span>
    <span class="tags-view__current">{{ route.meta.title }}</span>
  </div>
</template>

<script setup lang="ts">
import { useRoute } from "vue-router";
const route = useRoute();
</script>
